module.exports = __webpack_public_path__ + "img/佰时力.ba61a560.png";